// Module
var code = "<template> <require from=\"app/cm/admin/referral/referral-types\"></require> <referral-types></referral-types> </template> ";
// Exports
module.exports = code;